// Func = limiting Scope for this file
var lastScrollTop = 0;
var parallaxScrollEvent = [];
var parallaxScroll = [];

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function moveBodyAtAlertBanner(){
	setTimeout(() => {
		let bodyHTMLElement = document.querySelector(`body.alert_open`),
			headerHTMLelement = document.querySelector(`header#header`);
		
		if( !bodyHTMLElement ){
			console.log('no alert banner found');
			return false;
		}

		bodyHTMLElement.setAttribute('style', `padding-top:${headerHTMLelement.style.top} !important;`)

		if( document.querySelector(`.alert-close`) ){
			document.querySelector(`.alert-close`).addEventListener('click', () => {
				bodyHTMLElement.removeAttribute('style');
			});
		}
	}, 2000);
}

function expandContainer(){
	document.querySelectorAll(`.js-expandContainer`).forEach( expand_btn => {
		expand_btn.addEventListener( 'click', (e) => {
			e.preventDefault();
			let anchor = expand_btn.hash.substring(1);
			let sectionFromHref = document.getElementById(`${anchor}`);
			if( sectionFromHref ){
				let heightOfFirstChild = sectionFromHref.firstElementChild.clientHeight;
				if( sectionFromHref.getAttribute('style') == null ){
					sectionFromHref.setAttribute(`style`, `height:${heightOfFirstChild}px;`);
				}else{
					sectionFromHref.removeAttribute('style');
				}
			}
		} );
	} );
}

(function(){

	const burgerMenuBtn = document.getElementById('js-menu-trigger');
	const burgerMenuClose = document.getElementById('js-close-menu');
	const burgerMenu = document.getElementById('burger-menu');


	burgerMenuBtn.addEventListener('click', (e) =>{
		e.preventDefault();
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll');
	});


	burgerMenuClose.addEventListener('click', () =>{
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll');
	});

    let itemsMenu = document.querySelectorAll('.primary-navigation .primary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	});

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	/* vanilla JS fancybox */
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lbxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allCloseTerms = document.getElementsByClassName('js-close-terms');
		let allTermsLight = document.querySelectorAll('.terms-lbx');

		for(let j = 0; j < allCloseTerms.length; j++ ){
			allCloseTerms[j].addEventListener('click', function(e){
				e.preventDefault();
				allTermsLight.forEach(el => el.classList.remove('open'));
			});
		};

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}
	};

	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-lbx], a.js-lbxbtn, a.js-lightboxclose, a#js-close-form, a.js-expandContainer))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	};

	/* Cards Shortcode Mobile Functionality */
	const allCards = document.querySelectorAll('.cards .item');
	if(allCards.length > 0){
		allCards.forEach((el)=>{
			el.addEventListener('click', function(e){
				if(e.target != this.querySelector('.btn-2')){
					this.classList.toggle('active');
				}
			});
		});
	};

	/* Mobile Form Date Fields */
	const dateInputs = document.querySelectorAll('input[type="date"]');
	if (dateInputs) {
		dateInputs.forEach(function(input) {
			input.addEventListener('click', function() {
				this.classList.add('clicked');
			});
		});
	};

	/* ANIMATE FADE FOR TEXT, FORM & SITEMAP */
	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//prallax effect
	if(document.querySelectorAll('.js-parallax-img').length > 0){
		let imagesParallax = new IntersectionObserver(entries => {
            entries.forEach(function (entry, i) {
                if (entry.isIntersecting) {
                    
                    imgParallax(entry.target);
                    entry.target.classList.add('on-viewport')

                } else {
                    window.removeEventListener('scroll', parallaxScrollEvent[parseInt(entry.target.dataset.index)])
                    entry.target.classList.remove('on-viewport')
                }
            })
        },
        {
            threshold: 0
        });

        document.querySelectorAll('.js-parallax-img').forEach(function (element) {
            imagesParallax.observe(element);
        })

	}
	if(document.querySelectorAll('.js-with-arrow').length > 0){
        document.querySelectorAll('.js-with-arrow').forEach(box => {
			let limitHeight = window.innerHeight < 750 ? 400 : 600;
			(box.querySelector('.box').clientHeight > limitHeight) ? box.classList.add('taller'):null;
            box.addEventListener('scroll', () => {
                let isFullyScrolled = box.scrollTop + box.clientHeight >= (box.scrollHeight - 80);
                if(isFullyScrolled){
                    !box.parentElement.querySelector('.copy-arrow').classList.contains('hidden') ? box.parentElement.querySelector('.copy-arrow').classList.add('hidden') : null;
                } else {
                    box.parentElement.querySelector('.copy-arrow').classList.contains('hidden') ? box.parentElement.querySelector('.copy-arrow').classList.remove('hidden') : null;
                }
            });
            
        });
    }

})();

function imgParallax(element){
	let index = parseInt(element.dataset.index);
	let direction = parseInt(element.dataset.direction);
		
	let imageMove = function(){
		
		let initialMove = ((lastScrollTop - window.innerHeight) + 380) < 0 ? 0 : (lastScrollTop - window.innerHeight) + 380;
		let finalMove = initialMove * 0.09;
		
		element.setAttribute('data-move', finalMove.toFixed(2))
		element.querySelector('img').setAttribute('style', `transform:translateY(${direction == 1 ? '':'-'}${finalMove.toFixed(5)}px)`)
	}

	parallaxScrollEvent[index] = imageMove
	window.addEventListener('scroll', parallaxScrollEvent[index])

}


function scrollW(){
	let subNav = document.getElementsByClassName('sub-menu')[0];
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st;

	if(subNav != undefined){
		if(st > 550 && screen.width > 600){
			subNav.classList.add('scroll-fix');
		} else if(st > 300 && screen.width < 600) {
			subNav.classList.add('scroll-fix');
		} else {
			subNav.classList.remove('scroll-fix');
		}
	}
}

function animateto(target){
    let gotoTarget = offset(document.getElementById(target)).top - 120;
    let from     = window.pageYOffset
    let to       = gotoTarget
    let duration = 500;
    let start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)
} 

function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

//Mobile Submenu Funcionality
document.querySelectorAll('.burger-menu > .nav-container > ul > li > a').forEach(link => {
	link.addEventListener('click', e => {
		if (link.nextSibling.nextSibling != null) {
			document.querySelectorAll('.burger-menu > .nav-container > ul > li').forEach(item => {
				if (link.parentNode !== item) item.classList.remove('submenu-show');
			});
			e.preventDefault();
			link.parentNode.classList.toggle('submenu-show')
		}
	});
});

//add class for icon dropdown 
document.querySelectorAll('.burger-menu > .nav-container > ul > li > .sub-sub-menu').forEach(link => {
	let menu = link.parentNode.firstElementChild;
	menu.classList.add('icon-dropdown');
})

const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;
		
		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);
	
		const countDownDate = new Date(date).getTime();
		
		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;
	
			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}
	
			if (dateDiff < 0)
				clearInterval(timerInterval);
		}
	
		timer();
	
		const timerInterval = setInterval(timer, 1000);
	}

}

document.addEventListener('DOMContentLoaded', () => {
	let allFormsToAddAriaLabel = document.querySelectorAll(`form.form-module, form.email-signup`);
	if( allFormsToAddAriaLabel ){
		allFormsToAddAriaLabel.forEach( form => {
			let submitAriaLabel = '';
			switch (form.id) {
				case 'form_id-4000':
					submitAriaLabel = 'submit media inquiry form'
					break;

				case 'form_id-3997':
					submitAriaLabel = 'submit meetings and events rfp form'
					break;
				case 'form_id-4001':
					submitAriaLabel = 'submit contact form'
					break;

				case 'email-signup':
					submitAriaLabel = 'subscribe to our email database'
					break;

				default:
					submitAriaLabel = 'Submit form'
					break;
			}
			form.querySelector('button[type="submit"]').setAttribute( 'aria-label', submitAriaLabel)
		} );
	}
	if( document.querySelector(`.js-expandContainer`) ){
		expandContainer();
	}

	if( document.querySelector(`v-popups`) ){
		moveBodyAtAlertBanner();
	}
});

document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));